/**
 * TASK: validate the name; additional support for Norwegian names.
 * Name can't be blank, must be between 2 and 100 characters, and shouldn't contain restricted characters.
 * Restricted characters: |/\()"[]{}#%&=*@:<>!?+^~
 * @return True for valid name
 */
const validateName = (name: string) => {
  // Regex: Ensure the name is between 2 and 100 characters, doesn't contain restricted characters,
  // and allows valid Norwegian characters and spaces.
  const regex = /^[^|/\\()"[\]{}#%&=*@:<>!?+^~]{2,100}$/;

  // Trim whitespace before testing
  name = name.trim();

  // Validate the name against the regex
  return regex.test(name);
};

export default validateName;
